/* eslint-disable */
import {
    SearchBarDispatcher as SourceSearchBarDispatcher
} from 'SourceStore/SearchBar/SearchBar.dispatcher';

import CategoryListQuery from 'Query/CategoryList/CategoryList.query';

/** @namespace Scandipwa/Store/SearchBar/Dispatcher */
export class SearchBarDispatcher extends SourceSearchBarDispatcher {
    prepareRequest(options, dispatch) {
        return [
            super.prepareRequest(options, dispatch),
            CategoryListQuery.getQuery({
                name: {
                    match: options.args.search
                  }
            })
        ]
    }
}

export default new SearchBarDispatcher();
